// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"breadcrumb___PQxo-","ellipsis":"ellipsis___3V9Vf","wrapper":"wrapper___3LJyC","chevron":"chevron___1UZEJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumb/Breadcrumb.scss
// module id = 8wAc
// module chunks = 46